// The 6-digit code in the sign-in email: what counts as one, and when "send it
// again" may be offered. Pure (no React, no I/O) so the rules are pinned by a test
// and EmailCodeEntry stays a thin shell around them.

/** The code Supabase mails is always this long. */
export const CODE_LENGTH = 6

/** How long the person waits before "send it again" appears. Long enough for the
 *  mail to have arrived if it was going to, short enough that nobody sits on a
 *  dead end. (The auth server also holds its own cooldown between sends, which
 *  friendlyAuthError words kindly if it is still running.) */
export const RESEND_AFTER_MS = 60_000

/** Whatever was typed or pasted, reduced to its digits and cut to one code:
 *  "123 456", "123-456", " 123456\n" and "Your code is 123456" all become "123456".
 *  A paste longer than a code keeps its FIRST six digits, never a tail of them. */
export function codeDigits(raw: string | null | undefined): string {
  return (raw ?? '').replace(/\D/g, '').slice(0, CODE_LENGTH)
}

/** Is this a whole code, ready to send for checking? */
export function isWholeCode(digits: string): boolean {
  return digits.length === CODE_LENGTH
}
